import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {OfflineNetworkApiService} from '../network/offline-network-api.service';
import {HttpClient} from '@angular/common/http';
import {RoutingInterfaceFilterService} from '../../../../../network/utils/filters/routing-interface/routing-interface-filter.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineRoutingInterfaceApiService {

  constructor(private http: HttpClient,
              private offlineNetworkApiService: OfflineNetworkApiService) {}

  public getRoutingInterfacesForMap(params: any = {}): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map(mapData => {
      const routingInterfaces = OfflineNetworkApiService.objectToArray(mapData.routingInterfaces);

      return this.filterRIs(routingInterfaces, params);
    })).toPromise();
  }

  public getRoutingInterfaceForMap(id): Promise<any> {
    return this.offlineNetworkApiService.getOfflineMap().pipe(map(mapData => {
      return mapData.routingInterfaces[id];
    })).toPromise();
  }

  private filterRIs(routingInterfaces, params): any {
    return (params && params.filter) ?
      RoutingInterfaceFilterService.filter(routingInterfaces, params.filter) : routingInterfaces;
  }
}
